import { DomainDnsRecord } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Table } from '@tribeplatform/react-ui-kit/Table'

import { TableBody } from './TableBody.js'
import { TableSkeleton } from './TableSkeleton.js'

interface Props {
  dnsRecords: DomainDnsRecord[]
  isLoading?: boolean
}

export const DnsRecordsTable = ({ dnsRecords, isLoading }: Props) => {
  if (!dnsRecords.length && !isLoading) {
    return null
  }

  return (
    <div className="rounded-base border border-line-subdued">
      <Table>
        <Table.Header className="bg-surface-subdued">
          <Table.Row className="text-sm">
            <Table.HeaderCell>
              <T defaultMessage="Type" id="Generics.Type" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <T defaultMessage="Name" id="Generics.Name" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <T
                defaultMessage="Target/Value"
                id="Admin.DomainSettings.TargetOrValue"
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <T defaultMessage="Status" id="Generics.Status" />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {isLoading ? <TableSkeleton /> : <TableBody dnsRecords={dnsRecords} />}
      </Table>
    </div>
  )
}
